import React, { Component } from 'react'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Typography from 'material-ui/Typography'
import IconButton from 'material-ui/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import { withStyles } from 'material-ui/styles'
import classNames from 'classnames'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom"
import compose from 'lodash/fp/compose'
import { withAuthenticator } from 'aws-amplify-react'
// import { Auth } from 'aws-amplify'

import ClientsPage from './modules/clients/components/ClientsPage'
import NewOrganizationPage from './modules/organizations/containers/NewOrganizationPage'
import NavDrawer from './components/NavDrawer'

const drawerWidth = 240;

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 3,
  },
});

class App extends Component {
  state = {
    open: false
  }

  handleDrawerOpen = () => {
    this.setState({ open: true })
  }

  handleDrawerClose = () => {
    this.setState({ open: false })
  }

  // componentDidMount () {
  //   (async () => {
  //     // let user = await Auth.currentUserInfo()
  //     // let result = await Auth.updateUserAttributes(user, {
  //     //   'custom:organizationId': 'testing123'
  //     // })
  //     // let user = await Auth.currentSession()
  //     // console.info(user)
  //   })()
  // }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Router>
          <React.Fragment>
            <AppBar
              position="absolute"
              className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
            >
              <Toolbar disableGutters={!this.state.open}>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={this.handleDrawerOpen}
                  className={classNames(classes.menuButton, this.state.open && classes.hide)}
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="title" color="inherit" noWrap>
                  EZ Repair Shop
                </Typography>
              </Toolbar>
            </AppBar>
            <NavDrawer open={this.state.open} handleDrawerClose={this.handleDrawerClose} />
            <main className={classes.content}>
              <div className={classes.toolbar} />
              <Switch>
                <Route path="/" exact component={ClientsPage} />
                <Route path="/developer/inprogress/:activeStep" component={NewOrganizationPage} />
              </Switch>
            </main>
          </React.Fragment>
        </Router>
      </div>
    );
  }
}

export default compose(
  withAuthenticator,
  withStyles(styles, { withTheme: true })
)(App)



// WEBPACK FOOTER //
// ./src/App.js